import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/webhookStyles/webhookStyle.module.scss";
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import { useWebhookStore } from '../../../store/webhookStore';
import GlobalButton from '../../utility/globalButton/button';
import AddIcon from '@mui/icons-material/Add';
import GlobalPopUp from '../../utility/globalPopUp';
import CreateUpdateWebhookPopup from './createUpdateWebhookPopup';
import { configuredWebhookData, payloadConfigureWebhook, WebhookExternalConfig } from '../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface AvailableWebhookTableProps {
    getWebhookOrganizationListApi:  () => Promise<void>,
} 

const AvailableWebhookTable: React.FC<AvailableWebhookTableProps> = (props) => {

    const { getWebhookOrganizationListApi } = props;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    const [flagManageWebhookPopup, setFlagManageWebhookPopup] = useState<boolean>(false);
    const [selectedWebhook, setSelectedWebhook] = useState<WebhookExternalConfig | null>(null);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const webhookExternalData: WebhookExternalConfig[] | null = useWebhookStore((state) => state.webhookExternalData);
    const setWebhookExternalData = useWebhookStore((state) => state.setWebhookExternalData);
    const getWebhookExternalDataApi = useWebhookStore((state) => state.getWebhookExternalDataApi);
    const configuredWebhookData = useWebhookStore((state) => state.configuredWebhookData); 

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))
    
    const getWebhookExternalDataApiCall = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}))
        const res = await getWebhookExternalDataApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}))
    }

    useEffect(() => {
        getWebhookExternalDataApiCall();
    }, []) 

    const configureWebhook = async (webhook_external_id: string) => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const payload: payloadConfigureWebhook = {
            webhook_external_id: webhook_external_id,
        }
        const res = await agent.createUpdateWebhookOrganization.post(payload);
        if(!(res.status)){
            handleError(res);
        } else {
            showSuccess("Webhook configured successfully!")
            // Get Configured Webhook Call
            getWebhookOrganizationListApi();
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    } 

    const isWebhookConfigured = (webhook_external_id: string) => {
        if(configuredWebhookData && configuredWebhookData?.length > 0){
            const currentWebhook = configuredWebhookData?.find((webhook: configuredWebhookData) => webhook.webhook_external?.webhook_external_id == webhook_external_id); 
            if(currentWebhook){
                return true;
            }
        }
        return false;
    }

    return (
        <Grid container> 
           <Grid item className={globalStyles.fullwidth}>
                <Grid container gap={"10px"} direction={"column"}>
                    <Grid item className={globalStyles.fullwidth}>
                        <Typography className={styles.configuredWebhookTitle}>Available Webhook</Typography>
                    </Grid>
                    <Grid item className={globalStyles.fullwidth}>
                        <TableContainer className={`${styles.webhookTableContainer}`} sx={{ maxHeight: `350px !important` }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Company Name</TableCell>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Webhook Description</TableCell>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {webhookExternalData && webhookExternalData?.length > 0 ? 
                                        webhookExternalData?.map((webhook: WebhookExternalConfig, ind: number) => {
                                            return (
                                                <TableRow key={ind} className={dashboardStyles.cellRow}>    
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{webhook.webhook_external_company_name}</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{webhook.webhook_external_description || "-"}</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                        <Grid container gap={2} alignItems={"center"} flexWrap={"nowrap"}>
                                                            <Grid item>
                                                                {isWebhookConfigured(webhook.webhook_external_id) ? 
                                                                    <Grid item className={styles.alreadyConfiguredChip}>
                                                                        Already configured
                                                                    </Grid>
                                                                    :
                                                                    <GlobalButton
                                                                        buttonText={'Configure'}
                                                                        className='borderedButtonStyle'
                                                                        sx={{width: '100px !important', padding: '6px 10px !important', fontSize: "14px !important" }}
                                                                        onClick={() => configureWebhook(webhook.webhook_external_id)}
                                                                    />
                                                                }
                                                            </Grid>
                                                            <Grid item>
                                                                <GlobalButton
                                                                    buttonText="Edit"
                                                                    className='primaryButtonStyle'
                                                                    sx={{width: "100px !important", padding: '6px 10px !important', fontSize: "14px !important"}}
                                                                    onClick={() => {
                                                                        setSelectedWebhook(webhook);
                                                                        setFlagManageWebhookPopup(true);
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        : 
                                        <TableRow className={dashboardStyles.cellRow}>
                                            <TableCell colSpan={12} className={`${globalStyles.textCenter}`}>
                                                No Data Available
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Create New Webhook"
                                    className='primaryButtonStyle' 
                                    startIcon={<AddIcon />}
                                    sx={{ width: "220px !important" }}
                                    onClick={() => { 
                                        setSelectedWebhook(null);
                                        setFlagManageWebhookPopup(true);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>  
            
            <GlobalPopUp
                open={flagManageWebhookPopup}
                onClose={() => { setFlagManageWebhookPopup(false); }}
                handleClose={() => { setFlagManageWebhookPopup(false); }}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "750px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "850px"}
                borderRadius='10px'
                titlePadding='0px'
                overflow="hidden"
            >
                <CreateUpdateWebhookPopup
                    selectedWebhook={selectedWebhook}
                    setFlagManageWebhookPopup={setFlagManageWebhookPopup} 
                    getWebhookExternalDataApiCall={getWebhookExternalDataApiCall}
                    getWebhookOrganizationListApi={getWebhookOrganizationListApi}
                />
            </GlobalPopUp>
        </Grid>
    )
}

export default AvailableWebhookTable
